<template>
  <v-card v-if="datos">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ datos.key }} | {{ datos.direccion }}</v-toolbar-title>
      <!-- <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat>Descargar</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 v-for="(propietario, i) in datos.propietarios" :key="i">
            <documentosPropietario
              :propietario="propietario"
            />
          </v-flex>
          <!-- <pre>Mostrar: {{ mostrarDatos }}</pre> -->
          <!-- <pre>filtro1: {{ filtro1 }}</pre> -->
        </v-layout>
      </v-container>
    </v-card-text>
    <!-- <pre>{{datos.propietarios}}</pre> -->
  </v-card>
</template>

<script>
import documentosPropietario from "./documentos-adjuntos-propietarios";
export default {
  name: "DetalleAdjuntos",
  props: ["datos"],
  components: {
    documentosPropietario
  }
};
</script>
